import React from 'react';

/**
 * Reusable skeleton loader component for vendor service cards
 * Matches the layout of VendorServices component
 * 
 * @param {number} count - Number of skeleton cards to display (default: 6)
 * @param {string} className - Additional CSS classes
 * @param {object} cardProps - Props for individual card styling
 * @param {string} cardProps.width - Card width class (default: 'w-[calc((100%-5*1rem)/6)] min-w-[180px]')
 * @param {number} cardProps.imageHeight - Image skeleton height in pixels (default: 192 = h-48)
 */
const VendorServiceSkeleton = ({ 
  count = 6, 
  className = '',
  cardProps = {} 
}) => {
  const {
    width = 'w-[calc((100%-5*1rem)/6)] min-w-[180px]',
    imageHeight = 192
  } = cardProps;

  return (
    <div className={`flex gap-4 overflow-x-auto scrollbar-hide pb-4 ${className}`}>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className={`flex-shrink-0 ${width} animate-pulse`}
        >
          <div className="relative rounded-lg overflow-hidden">
            {/* Image Skeleton */}
            <div 
              className="relative bg-gray-200 rounded-lg"
              style={{ height: `${imageHeight}px` }}
            >
              <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
            </div>

            {/* Content Skeleton */}
            <div className="mt-3 space-y-2">
              {/* Title and Rating */}
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="h-4 bg-gray-200 rounded w-3/4 mb-2">
                    <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
                  </div>
                </div>
                <div className="ml-2 flex items-center">
                  <div className="h-3 w-8 bg-gray-200 rounded">
                    <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
                  </div>
                </div>
              </div>

              {/* Location */}
              <div className="h-3 bg-gray-200 rounded w-2/3">
                <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
              </div>

              {/* Price */}
              <div className="h-4 bg-gray-200 rounded w-1/2 mt-2">
                <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default VendorServiceSkeleton;

